<template>
  <div>
    <div class="pa-6">
      <v-container class="pa-0" fluid>
        <v-row>
          <v-col cols="6">
            <div class="smartphone">
              <v-container class="smartphone-block pa-0" fill-height>
                <v-row class="title-row" align="center">
                  <mf-icon color="#b3cafe" fill class="ml-3"> arrow_back_ios </mf-icon>
                  <mf-icon color="#b3cafe" fill large> lens </mf-icon>
                  <div class="ml-2">
                    <div class="first-line" />
                    <div class="second-line" />
                  </div>
                  <v-spacer />
                  <mf-icon color="#b3cafe" fill large> stop </mf-icon>
                  <mf-icon color="#b3cafe" fill class="mr-3" large> stop </mf-icon>
                  <mf-icon color="#b3cafe" class="mr-3" large> more_vert </mf-icon>
                </v-row>
                <v-row class="content-row content-row-expanded" justify="end" fill-height>
                  <v-col class="bubble-block" align-self="end">
                    <div v-if="(message && message.text) || fileUrl" class="message">
                      <v-img v-if="fileUrl" max-height="200px" width="100%" eager position="center center" :src="fileUrl" />
                      <div class="d-flex justify-end mt-1">
                        <download-image-button :url="fileUrl" />
                      </div>
                      <div>
                        <span v-for="(msg, index) of splittedText" :key="index" v-html="getWhatsappRevisedText(msg)" />
                      </div>
                      <div v-if="optoutMessage.active">
                        <br />
                        <span>{{ optoutMessage.interpolated_text }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="message-box">
              <v-tooltip top :disabled="!disabled">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <file-upload-card class="file-upload" :disabled="disabled" :file-properties.sync="fileProperties" />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}.</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>

              <div class="mb-6">
                <div class="d-flex justify-space-between align-center">
                  <h3 class="whatsapp-card-title">
                    Mensagem da campanha
                    <v-tooltip right max-width="300px">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <mf-icon small color="cinza-0" class="ml-1">info</mf-icon>
                        </span>
                      </template>
                      <span>Por padrão, ao final de toda mensagem será enviada para seus clientes a opção de descadastramento.</span>
                    </v-tooltip>
                  </h3>
                  <div class="d-flex justify-end">
                    <template-message-modal v-model="selectedTemplate" :mode="['WHATSAPP']" />
                    <message-variables />
                  </div>
                </div>

                <v-tooltip top :disabled="!disabled">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <mf-textarea-emoji
                        v-model="campaign.shotConfiguration.whatsapp.message.text"
                        class="textarea"
                        hide-details
                        :disabled="disabled"
                        :max-length="2000"
                        outlined
                        no-resize
                        background-color="white"
                        height="150"
                        rows="4"
                        counter="2000"
                        :error-messages="errorText"
                      />
                    </div>
                  </template>
                  <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}.</span>
                  <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <clients-range-slider class="padding-channel my-5" channel="whatsapp" :segments="campaign.segments" :version="campaign.version" />
      <v-container class="pa-0" fluid>
        <v-row>
          <v-col cols="6">
            <div class="pa-5 campaign-shooting">
              <v-row no-gutters>
                <v-col>
                  <h3 class="whatsapp-card-title pl-4 pt-2">Disparar campanha para:</h3>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <p class="whatsapp-card-text pl-4">
                    Selecione os clientes que devem receber essa campanha. Só serão contabilizados na campanha clientes que já realizaram o cadastro no seu
                    WhatsApp.
                  </p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="pl-3">
                  <v-tooltip top :disabled="!disabled">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-radio-group v-model="campaign.shotConfiguration.whatsapp.targeting_mode" class="mt-0 mb-3" dense hide-details :disabled="disabled">
                          <v-radio label="Todos os contatos" color="primary" value="ALL" :disabled="hasSegments" />
                          <v-radio label="Contatos no clube" color="primary" value="LOYALTY" :disabled="hasSegments" />
                          <v-radio color="primary" value="SEGMENTED" :disabled="!hasSegments">
                            <template v-slot:label>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on"> Segmentos <mf-icon class="help-icon ml-1 mt-n1" small>info</mf-icon> </span>
                                </template>
                                <span> Segmentos podem ser inseridos ou alterados durante a definição do orçamento da sua campanha. </span>
                              </v-tooltip>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                    </template>
                    <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}.</span>
                    <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="6">
            <disparadores
              ref="disparadores"
              is-maria-campaign
              :disabled="disabled"
              :chosen-senders.sync="campaign.senders"
              @update:chosenSenders="updateSenders"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <credit-entry
      title="Quantidade de disparos whatsapp disponíveis"
      :credits.sync="campaign.shotConfiguration.whatsapp.credits"
      :disabled="disabled"
      :is-maria-campaign-activated="isMariaCampaignActivated"
      :is-maria-campaign-finished="isMariaCampaignFinished"
      channel-type="whatsapp"
      :validations="
        getSafe(() => validations.campaign.shotConfiguration.whatsapp.credits.$error) ? 'Defina a quantidade de créditos disponíveis nesta campanha.' : ''
      "
    />
  </div>
</template>

<script>
import TemplateMessageModal from '@/components/template-message/TemplateMessageModal.vue'
import { QUERY_GET_MESSAGE_BY_TYPE } from '@/modules/maria/campanha-da-maria/graphql'
import ClientsRangeSlider from '@/modules/maria/campanha-da-maria/views/components/ClientsRangeSlider.vue'
import CreditEntry from '@/modules/maria/campanha-da-maria/views/components/CreditEntry.vue'
import FileUploadCard from '@/modules/campanhas/whatsapp/views/components/FileUploadCard.vue'
import Disparadores from '@/modules/campanhas/whatsapp/views/components/Disparadores.vue'
import { textVariables } from '@/mixins/text-variables'
import DownloadImageButton from '@/components/DownloadImageButton.vue'

export default {
  name: 'WhatsappChannel',

  components: {
    ClientsRangeSlider,
    CreditEntry,
    FileUploadCard,
    Disparadores,
    TemplateMessageModal,
    DownloadImageButton,
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
  },

  mixins: [textVariables],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    validations: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    optoutMessage: {},
    chosenSenders: [],
    fileProperties: {},
    hasSegments: false,
    hasFile: false,
    tryingToSaveAsDraft: false,
    selectedTemplate: {},
  }),

  computed: {
    campaignVersion() {
      return this.campaign.version === 2 || !this.campaign._id ? 'V2' : 'V1'
    },
    message() {
      return this.campaign.shotConfiguration.whatsapp.message
    },
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? 'concluída' : 'ativa'
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    fileUrl() {
      return this.fileProperties && this.fileProperties.thumbnail_url
    },
    splittedText() {
      if (!this.message.text) return []
      return this.message.text.split('\n')
    },
    errorText() {
      if (
        !this.validations.campaign.shotConfiguration.whatsapp ||
        !this.validations.campaign.shotConfiguration.whatsapp.message ||
        !this.validations.campaign.shotConfiguration.whatsapp.message.text
      ) {
        return ''
      }
      if (this.validations.campaign.shotConfiguration.whatsapp.message.text.$error) {
        if (!this.validations.campaign.shotConfiguration.whatsapp.message.text.required) return 'Adicione uma mensagem para esta campanha.'
        else if (!this.validations.campaign.shotConfiguration.whatsapp.message.text.maxLength) return 'O texto da mensagem excedeu 2000 caracteres.'
        else if (!this.validations.campaign.shotConfiguration.whatsapp.message.text.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
  },

  apollo: {
    optoutMessage: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      update({ getMessageByType }) {
        return getMessageByType
      },
    },
  },

  watch: {
    fileProperties(value) {
      if (value && Object.keys(value).length) {
        this.hasFile = true
      } else {
        this.campaign.shotConfiguration.whatsapp.message.text = ''
        this.hasFile = false
      }
      this.campaign.shotConfiguration.whatsapp.message.attachment = this.fileProperties
    },
    selectedTemplate() {
      this.campaign.shotConfiguration.whatsapp.message.text = this.selectedTemplate.message
    },
  },

  mounted() {
    this.hasSegments = !!this.campaign.segments.length
    if (this.hasSegments) this.campaign.shotConfiguration.whatsapp.targeting_mode = 'SEGMENTED'
    else {
      if (!this.campaign.shotConfiguration.whatsapp.targeting_mode) {
        this.campaign.shotConfiguration.whatsapp.targeting_mode = 'ALL'
      }
    }
    if (Object.keys(this.campaign.shotConfiguration.whatsapp.message.attachment).length) {
      this.fileProperties = this.campaign.shotConfiguration.whatsapp.message.attachment
    }
  },

  methods: {
    getWhatsappRevisedText(text) {
      return this.getRevisedText(`${text}<br />`)
    },

    updateSenders(senders) {
      this.campaign.senders = senders
    },
  },
}
</script>

<style lang="scss">
.smartphone {
  height: 496px;
  .smartphone-block {
    margin-right: -12px;
    .message-preview-title {
      margin-left: -12px;
      padding-bottom: 30px;
    }
    .title-row {
      background-color: #d6e3fe;
      height: 60px;
      .first-line {
        width: 85px;
        height: 10px;
        background-color: #b3cafe;
        border-radius: 2px;
      }
      .second-line {
        width: 150px;
        height: 8px;
        background-color: #b3cafe;
        margin-top: 4px;
        border-radius: 2px;
      }
      i {
        color: #b3cafe;
      }
    }
    .content-row-dense {
      height: 478px;
    }
    .content-row-expanded {
      height: 436px;
    }
    .content-row {
      overflow: auto;
      background-color: #ecf2fe;
      .bubble-block {
        max-width: 85%;
        .message {
          border-radius: 4px;
          background-color: #b5caf7 !important;
          padding: 8px;
          color: $marca-0-l20 !important;
        }

        .variable-highlight {
          color: $marca-1;
        }
      }
    }
  }
}

.message-box {
  height: 496px;
  background-color: $cinza-l90;
  padding: 50px 20px 35px 32px;
  border-radius: 4px;
}

.whatsapp-file-upload.file-upload.v-card.v-sheet.theme--light {
  border: none;
  box-shadow: none !important;
  background-color: $cinza-l90;

  .v-card__text {
    padding: 0;
  }
}

div.pa-6.padding-channel.my-5 {
  padding: 0 !important;
}

.v-card.v-sheet.theme--light.disparadores {
  background-color: $cinza-l90;
  padding: 20px !important;
  box-shadow: none;

  .v-data-table {
    background-color: $cinza-l90;
    width: calc(100% + 40px);
    margin-left: -20px;
  }
}

.whatsapp-card-title {
  font-size: 18px;
  line-height: 120%;
  color: $cinza-d10;
}

.whatsapp-card-text {
  font-size: 14px;
  line-height: 150%;
  color: $cinza-0;
}

.campaign-shooting {
  height: 363px;
  background-color: $cinza-l90;
}

.v-radio--is-disabled {
  pointer-events: auto !important;

  .v-input--selection-controls__input {
    pointer-events: none;
  }
}

.variable-highlight {
  color: $marca-1;
}

.variable-error {
  color: #d83e3e !important;
}

.variable-error-super {
  .variable-highlight {
    color: $marca-1 !important;
  }
  color: #d83e3e !important;
}
</style>
